module.exports = __webpack_public_path__ + "img/Strip-Front-B2-Cb-Jc.0c399a07.png";